var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isTealiumEnabled)?_c('div',[_c('script',{attrs:{"type":"application/javascript","src":"/tealium/setting.js"}}),_c('script',{attrs:{"type":"application/javascript","src":_vm.scriptSource}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }